import moment from "moment";
import { _ACTIONS, _SWAL_ICONS } from "./_constants";
import { createToast } from "./toast";
import { RequestHelper } from "./requestHelper";

/**
 * Convertit une date en instant UTC utilisable dans un filtre de date de l'API.
 *
 * La chaîne retournée est au format ISO 8601 UTC (suffixe "Z") : elle ne
 * contient donc aucun offset "+HH:MM". C'est volontaire : dans une query
 * string un "+" non encodé est décodé comme un espace, la date devient
 * impossible à parser et API Platform ignore alors silencieusement le filtre
 * (la collection est renvoyée en entier).
 *
 * @param {Object} date objet moment (ou null)
 * @param {"start"|"end"} boundary borne de la journée à retenir
 *
 * @returns {string} date ISO UTC, ou "" si la date est absente ou invalide
 */
export function toApiDate(date, boundary = "start") {
  if (!date || typeof date.isValid !== "function" || !date.isValid()) {
    return "";
  }

  return moment(date)
    [boundary === "end" ? "endOf" : "startOf"]("day")
    .toISOString();
}

/**
 * Période sélectionnée par défaut au premier affichage des écrans de liste :
 * les 6 derniers mois glissants à partir de la journée en cours.
 *
 * @returns {{debut: Object, fin: Object}} bornes moment de la période
 */
export function getDefaultPeriodeRange() {
  return {
    debut: moment().subtract(6, "month"),
    fin: moment(),
  };
}

/**
 * Créer des options pour un select a partir d'une réponse API
 *
 * @param {Object} response
 * @returns
 */
export function buildOptionsFromResponse(
  response,
  valueKey = "id",
  labelKey = "name",
) {
  if (!response) return [];

  return response["hydra:member"].map((item) => ({
    value: item[valueKey],
    label: item[labelKey],
  }));
}

/**
 *
 * @param {Object} formData
 *
 * @returns {Object}
 *
 */
export function getQueryParamsFromFormData(formData, mode) {
  const params = {};
  //Boucler sur l'objet formData
  //Si la valeur est vide ou null, on ne l'ajoute pas
  //Sinon on l'ajoute dans params
  for (let key in formData) {
    let value = formData[key];
    if (mode === "edit" && key.includes(".")) {
      continue;
    }
    if (
      (key.includes("date") || key.includes("At")) &&
      value !== "" &&
      value !== null
    ) {
      key = key.includes("AF")
        ? key.replace("AF", "[after]")
        : key.replace("BF", "[before]");
      params[key] = value;
      continue;
    }
    if (value !== "" && value !== null) {
      params[key] = value;
    }
  }

  return params;
}

/**
 * Envoie un requete directement au onChange d'un select pour modifier une valeur en BDD
 *
 * @param {*} value
 * @param {*} field
 * @param {*} url
 */
export async function editInstantRequest(value, url, field) {
  const requestHelper = new RequestHelper();
  const arrayFields = ["bouquet", "renteViagere", "comptant"];
  if (arrayFields.includes(field)) {
    value = isNaN(value) ? 0 : value;
  }

  return await requestHelper
    .doRequest(_ACTIONS.PUT, url, { [field]: value })
    .then((response) => {
      if (response.status == 200) {
        // Gardert le toast pour plus tard peut etre
        // createToast(
        //   _SWAL_ICONS.success,
        //   "La modification du champ a été effectuée avec succès"
        // );

        return response.data;
      } else {
        createToast(
          _SWAL_ICONS.error,
          "Une erreur est survenue lors de la modification",
        );
        return response.data;
      }
    });
}
